import React from 'react';

interface Props {
  percent: number;
  height?: number;
}

const ProgressBar: React.FC<Props> = ({ percent, height = 8 }) => {
  const p = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className="w-full bg-gray-200 rounded" style={{ height }}>
      <div
        className="bg-blue-600 h-full rounded"
        style={{ width: `${p}%`, transition: 'width 200ms ease' }}
      />
    </div>
  );
};

export default ProgressBar;
